const sendManagerRequest = {
  sendRequest: 'Надіслати запит',
  personalManagerRequest: 'Запит на персонального менеджера',
  pleaseFillYourProfile: "Будь ласка, заповніть свій профіль та залиште будь-які контактні дані для кращого зв'язку.",
  myContact: 'Мій контакт',
  messengerId: 'Ваш ідентифікатор месенджера',
  messenger: 'Месенджер',
  requestForPersonalManager: "Запит на призначення персонального менеджера надіслано. Ваш новий персональний менеджер незабаром зв'яжеться з вами.",
};

export default sendManagerRequest;
